import { getComp } from '../../../../../utils/utils/DI'
import { RequestType } from '../../../types/Request.type'
import {
  ChangeDetailsFormType,
  ChangeInfoFormType,
  ChangePaymentFormType,
} from './getFormSchema'

export const getDefaultValues = (
  request: RequestType,
  financialSources: any,
  reasonName: any,
): ChangePaymentFormType => {
  const financeSourceItem = financialSources.find(
    (el: any) => el.id === request.financialSourceId,
  )

  return {
    address: request.address,
    addressType: request.addressType,
    apartment: request.apartment,
    building: request.building,
    district: request.district,
    house: request.house,
    locality: request.locality,
    financialSourceId: financeSourceItem
      ? {
          key: financeSourceItem.id,
          value: financeSourceItem.name,
          iconSrc: financeSourceItem.imageSrc,
        }
      : null,
    reasonId: {
      key: request.reasonId ?? 1,
      value: reasonName ?? 'Не определена',
    },
    territory: request.territory,
  }
}

export const getDefaultInfoValues = (
  request: RequestType,
): ChangeInfoFormType => {
  return {
    address: request.address,
    addressType: request.addressType,
    apartment: request.apartment,
    building: request.building,
    district: request.district,
    house: request.house,
    locality: request.locality,
    territory: request.territory,
    name: request.name,
    patronymic: request.patronymic,
    phone: request.phone,
    surname: request.surname,
    updateComment: '',
    preferentialCategory: request.preferentialCategory,
    categories: request.categories,
  }
}

export const getDefaultDetailsValues = (
  request: RequestType,
): ChangeDetailsFormType => {
  const { getInstallationReasonName } = getComp('InstallationReasonStore')
  const reasonName = getInstallationReasonName(request.reasonId)
  const { getSenderId } = getComp('SendersStore')

  return {
    senderId: request.sender
      ? {
          key: getSenderId(request.sender),
          value: request.sender,
        }
      : null,
    reasonId: {
      key: request.reasonId ?? 1,
      value: reasonName ?? 'Не определена',
    },
    updateComment: null,
  }
}
